function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 63,
  cy: 63,
  r: 61.5,
  stroke: "#fff",
  strokeWidth: 3
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M76.5 54.667h-1.917V50.75c0-5.405-4.293-9.792-9.583-9.792s-9.584 4.387-9.584 9.792v3.917H53.5c-2.108 0-3.834 1.762-3.834 3.916v19.584c0 2.154 1.726 3.916 3.834 3.916h23c2.108 0 3.833-1.762 3.833-3.916V58.583c0-2.154-1.725-3.916-3.833-3.916zM65 72.292c-2.108 0-3.834-1.763-3.834-3.917s1.726-3.917 3.834-3.917 3.833 1.763 3.833 3.917-1.725 3.917-3.833 3.917zm5.942-17.625H59.058V50.75c0-3.349 2.664-6.07 5.942-6.07 3.277 0 5.942 2.721 5.942 6.07v3.917z",
  fill: "#fff"
});

const SvgLockCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 126 126",
  fill: "none"
}, props), _ref, _ref2);

export default SvgLockCircle;